import { PagePending } from "@/components/ui/PagePending";
import { seo } from "@/utils/seo";
import { createFileRoute, lazyRouteComponent } from "@tanstack/react-router";

export const Route = createFileRoute("/supporter/$supporterId/reports")({
  pendingComponent: PagePending,
  component: lazyRouteComponent(() => import("./+Reports")),
  head: () => ({ meta: seo({ title: "Reports" }) }),
});
